export const getCookie = (name: string, initialValue?: string): string | null => {
  if (typeof window === 'undefined') return null;

  const value = document.cookie.split('; ').reduce((r, v) => {
    const parts = v.split('=');
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, '');

  return value ? value : initialValue || null;
};

export default getCookie;
